import { RequiredRule, Validator } from 'devextreme-react/validator';
import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { AR, OrderStatus } from '../../../../types/enums';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { formatShortDate } from '../../../../utils/date-utils';
import { TextBoxWithDelay } from '../../../../components';

export default function ActualShipDatePanel() {

	const { order, modifyOrder } = useContext(PurchaseOrderContext);

	const isOrderReadonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending;

	const isReadOnly = !order.details.activeARs.includes(AR.PODistributorToEnterShipDate) || isOrderReadonly;
	const isRequired = !isReadOnly;

	return (
		<Panel header={'Dates'} >
			<Field label="Requested Ship Date">
				{formatShortDate(order.details.requestedShipDate)}
			</Field>
			<Field label="Validated Ship Date" >
				{formatShortDate(order.details.validatedShipDate)}
			</Field>
			<Field label="Actual Ship Date" >
				{formatShortDate(order.details.actualShipDate)}
			</Field>
			<Field label="SSCC" visible={order.details.isGS1128} >
				<TextBoxWithDelay
					value={order.details.GS1128}
					onTextChanged={(value) => modifyOrder({ ...order.details, GS1128: value })}
					textChangeDelay={500}
					readOnly={isReadOnly}
					className={isRequired ? 'required' : ''}
				>
					<Validator>
						{
							isRequired && order.modified &&
							<RequiredRule message={'SSCC is required'} />
						}
					</Validator>
				</TextBoxWithDelay>
			</Field>
		</Panel>
	);
}
